import React from 'react';

export default function SponsorsPage() {
  return (
    <div className="dashboard">
      <h1>Sponsors</h1>

      <div className="stream-setup">
        <h2>Partner With Ninty</h2>
        <p style={{ fontSize: '0.95rem', color: '#adadb8', lineHeight: 1.7, marginBottom: '20px' }}>
          Ninty connects brands with authentic, engaged communities. Our streamers build real relationships with their audiences — and your brand can be part of that.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '14px', marginBottom: '24px' }}>
          {[
            { title: 'Stream Sponsorships', desc: 'Sponsor individual streams or streamers with custom integrations', icon: '1' },
            { title: 'Category Takeovers', desc: 'Feature your brand across an entire category for maximum visibility', icon: '2' },
            { title: 'Platform Ads', desc: 'Non-intrusive banner and pre-roll placements across Ninty', icon: '3' },
            { title: 'Custom Campaigns', desc: 'Work with our team to build something unique for your brand', icon: '4' },
          ].map(item => (
            <div key={item.icon} style={{ padding: '20px', background: '#0e0e10', borderRadius: '2px', border: '1px solid #2a2a2e', boxShadow: '2px 2px 0 rgba(0,0,0,0.3)' }}>
              <div style={{ fontFamily: 'var(--font-pixel)', fontSize: '0.7rem', color: '#ffd700', marginBottom: '10px' }}>{item.icon}</div>
              <div style={{ fontWeight: 800, fontSize: '0.95rem', marginBottom: '6px' }}>{item.title}</div>
              <div style={{ fontSize: '0.82rem', color: '#adadb8', lineHeight: 1.5 }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Why Ninty?</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {[
            { stat: '90%', label: 'of revenue goes directly to creators — they love being here' },
            { stat: '5%', label: 'of every transaction supports charity — your brand does good' },
            { stat: '0%', label: 'tolerance for bots and spam — real engagement, real people' },
          ].map((s, i) => (
            <div key={i} style={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
              <span style={{ fontFamily: 'var(--font-pixel)', fontSize: '0.9rem', color: 'var(--accent)', minWidth: '50px' }}>{s.stat}</span>
              <span style={{ fontSize: '0.88rem', color: '#adadb8' }}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Get in Touch</h2>
        <p style={{ fontSize: '0.9rem', color: '#adadb8', lineHeight: 1.6, marginBottom: '16px' }}>
          Interested in sponsoring on Ninty? We'd love to hear from you.
        </p>
        <a href="mailto:sponsors@ninty.live" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          sponsors@ninty.live
        </a>
      </div>
    </div>
  );
}
